

















































































































































































import { exportLoop } from "@/utils/export";
import {
  getSalaryOrderDetailApi,
  exportSalaryOrderDetailApi,
  deleteSalaryOrderApi,
  editStaffSalaryOrderData,
  editStaffSalaryOrderApi,
  confirmSalaryOrderApi,
} from "@/api/salary";
import { Vue, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  infoData = {
    name: "",
    staff: {},
  };
  tableHeadData: string[] = [];
  tableData: any[] = [];
  created() {
    const sid = this.$route.query.id;
    getSalaryOrderDetailApi({
      salary_id: Number(sid),
    }).then((res: any) => {
      if (res.data.sub_list[0]) {
        if (res.data.sub_list[0].item_list.length > 0) {
          res.data.sub_list[0].item_list.map((item: any) => {
            this.tableHeadData.push(item.item_name);
          });
        }
      }
      res.data.sub_list.map((item: any) => {
        item.editing = false;
        item.item_list.map((it: any) => {
          it.amount_cache = it.amount;
        });
      });
      this.infoData = res.data;
      this.tableData = res.data.sub_list;
    });
  }
  handleExport() {
    exportSalaryOrderDetailApi({
      salary_id: Number(this.$route.query.id),
    }).then((res: any) => {
      exportLoop(res.data.task_id);
    });
  }
  handleDelete() {
    this.$confirm("确定删除？", "删除结算", {
      confirmButtonText: "确定",
      confirmButtonClass: "mwow-button-filled success mini",
      cancelButtonText: "取消",
      cancelButtonClass: "mwow-button-filled mini",
      iconClass: "mwow-icon-error",
    })
      .then(() => {
        deleteSalaryOrderApi({
          salary_id: Number(this.$route.query.id),
        }).then(() => {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.$router.go(-1);
        });
      })
      .catch(() => {});
  }
  handleItemSum(i: number) {
    let amount = 0;
    this.tableData[i].item_list.map(
      (item: { amount: number | string; item_type: number }) => {
        if (item.item_type === 2) {
          amount = amount - Number(item.amount);
        } else {
          amount = amount + Number(item.amount);
        }
      }
    );
    this.tableData[i].amount = Number(amount.toFixed(2));
  }
  handleCancelItem(i: number) {
    this.tableData[i].item_list.map((item: any) => {
      item.amount = item.amount_cache;
    });
    this.tableData[i].editing = false;
  }
  handleSaveItem(
    data: {
      amount: number;
      salary_sub_id: number;
      item_list: { amount: string; item_id: number }[];
    },
    i: number
  ) {
    if (Number(data.amount) < 0) {
      this.$message({
        type: "warning",
        message: "结算工资小于0元，请重新核实",
      });
      return false;
    }
    this.$confirm(
      "请再次核对工资是否正确，确定保存工资？",
      `保存 - ${this.infoData.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        const params: editStaffSalaryOrderData = {
          salary_sub_id: data.salary_sub_id,
          item_list: data.item_list.map((item) => {
            return {
              item_id: item.item_id,
              amount: item.amount,
            };
          }),
        };
        editStaffSalaryOrderApi(params).then(() => {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.tableData[i].editing = false;
        });
      })
      .catch(() => {});
  }
  toStaffSalaryDetail(item: any) {
    this.$router.push({
      name: "staffPerformanceDetail",
      query: {
        staff_id: item.staff_id,
        salary_id: item.salary_id,
      },
    });
  }
  handleSubmit() {
    this.$confirm(
      "结算后，会生成工资明细记录，且数据将不可修改，请再次核对是否正确，确定要结算工资？",
      `确认结算  - ${this.infoData.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        confirmSalaryOrderApi({
          salary_id: Number(this.$route.query.id),
        }).then(() => {
          this.$message({
            type: "success",
            message: "确认成功",
          });
          this.$router.go(-1);
        });
      })
      .catch();
  }
}
